import React from 'react';
import { radii, typography, getActiveTheme } from './tokens';

export default function Badge({ label, variant = 'neutral', className = '', style = {} }) {
  const theme = getActiveTheme();
  const variantColor = (v) => {
    if (v === 'ok' || v === 'success') return theme.success;
    if (v === 'warning') return theme.warning;
    if (v === 'danger') return theme.danger;
    return theme.mutedText; // neutral
  };
  const color = variantColor(variant);
  return (
    <span
      className={`inline-flex items-center text-xs px-2 py-0.5 ${className}`}
      style={{
        borderRadius: radii.sm,
        color: theme.text,
        background: `${color}20`, // soft tint
        border: `1px solid ${color}55`,
        fontSize: typography.meta.fontSize,
        lineHeight: typography.meta.lineHeight,
        ...style,
      }}
    >
      {label}
    </span>
  );
}
